import { Typography, Link, Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { axiosInstance } from '../../../assets/utils/axiosInstance';
import { isRESTAPIError } from '../../../assets/utils/helpers';
import ErrorType from '../../../interfaces/ErrorType';

interface RedirectUrl {
  redirect_url: string;
  token: string;
}

const CustomerKnowledgeBase = () => {
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState<ErrorType>({
    errorType: false,
    message: '',
  });
  const [redirectUrl, setRedirectUrl] = useState<RedirectUrl>({
    redirect_url: '',
    token: '',
  });

  useEffect(() => {
    async function generateCustomerKnowledgeURL() {
      setLoading(true);
      try {
        const fetchRedirectUrl = await axiosInstance().get(
          '/tenant/knowledge-base',
        );
        window.open(fetchRedirectUrl.data.redirect_url);
        setRedirectUrl(fetchRedirectUrl.data);
      } catch (err) {
        if (isRESTAPIError(err)) {
          setErrorState({
            errorType: true,
            message: err.message,
          });
        } else {
          setErrorState({
            errorType: false,
            message: 'An unexpected error occurred.',
          });
        }
      } finally {
        setLoading(false);
      }
    }
    generateCustomerKnowledgeURL();
  }, []);

  if (errorState.errorType)
    return (
        <Box
          sx={{
            border: '1px solid #D6D6D6',
            borderRadius: '6px',
            maxHeight: '551px',
            padding: 3,
            bgcolor: '#FFF',
          }}
        >
          <Typography>{errorState.message}</Typography>
        </Box>
    );

  if (!loading)
    return (
        <Box
          sx={{
            border: '1px solid #D6D6D6',
            borderRadius: '6px',
            maxHeight: '551px',
            padding: 3,
            bgcolor: '#FFF',
          }}
        >
          <Typography component='div'>
            <Link
              href={redirectUrl.redirect_url}
              target='_blank'
              color='#00CECF'
            >
              Click here
            </Link>{' '}
            if the page doesn&apos;t open automatically
          </Typography>
        </Box>
    );

  return null;
};

export default CustomerKnowledgeBase;
